export default __webpack_public_path__ + "static/media/actualidad.11cb0863.svg";